module.exports = __webpack_public_path__ + "static/favicon-b0d315fcc63389b50a2cb919da7dd8c0.png";